import { useCallback, useEffect, useState } from 'react';
import { addMobileDetectionListener, shouldShowMobileInterface } from '../../utils/mobileDetection';
import { LanguageProvider } from '../Mobile/contexts/LanguageContext';
import DesktopLegalPage from '../desktop/legal/DesktopLegalPage';
import MobileLegalPage from '../Mobile/legal/MobileLegalPage';
import { getLegalPath, getLegalRouteKey } from './legalRoutes';

const LegalRouter = ({ initialPathname }) => {
  const [currentPath, setCurrentPath] = useState(() => {
    if (initialPathname) return initialPathname;
    if (typeof window === 'undefined') return '/privacy';
    return window.location.pathname || '/privacy';
  });
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined') return false;
    return shouldShowMobileInterface();
  });

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;

    const handlePopState = () => {
      setCurrentPath(window.location.pathname || '/privacy');
    };

    window.addEventListener('popstate', handlePopState);

    const cleanupMobileListener = addMobileDetectionListener((data) => {
      setIsMobile(Boolean(data?.isMobile));
    });

    return () => {
      window.removeEventListener('popstate', handlePopState);
      cleanupMobileListener();
    };
  }, []);

  const handleNavigate = useCallback((nextKey) => {
    const nextPath = getLegalPath(nextKey);
    if (!nextPath) return;

    if (typeof window !== 'undefined') {
      window.history.pushState({}, '', nextPath);
      window.scrollTo(0, 0);
    }
    setCurrentPath(nextPath);
  }, []);

  const pageKey = getLegalRouteKey(currentPath);

  useEffect(() => {
    if (!pageKey && typeof window !== 'undefined') {
      const fallback = currentPath || '/';
      window.location.href = fallback;
    }
  }, [pageKey, currentPath]);

  if (!pageKey) {
    return null;
  }

  const LegalComponent = isMobile ? MobileLegalPage : DesktopLegalPage;

  return (
    <LanguageProvider>
      <LegalComponent pageKey={pageKey} onNavigate={handleNavigate} />
    </LanguageProvider>
  );
};

export default LegalRouter;
